import { useQuery } from '@tanstack/react-query';
import CitiesService from '../../services/CitiesService';

export const cityKeys = {
  all: ['cities'],
  list: () => [...cityKeys.all, 'list'],
  highlights: () => [...cityKeys.all, 'highlights'],
  detail: (id) => [...cityKeys.all, 'detail', id],
};

export function useCityDetail(cityId) {
  return useQuery({
    queryKey: cityKeys.detail(cityId),
    queryFn: () => CitiesService.listIdCities(cityId),
    enabled: !!cityId,
  });
}

export function useCities() {
  return useQuery({
    queryKey: cityKeys.list(),
    queryFn: () => CitiesService.listCities(),
  });
}

export function useCitiesHighlights() {
  return useQuery({
    queryKey: cityKeys.highlights(),
    queryFn: () => CitiesService.listCitiesHighlights(),
  });
}
